<template>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in swiperItems" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev">
      </div>
      <div class="swiper-button-next">
      </div>
    </div>
  </template>
  
  <script>
  import Swiper from 'swiper';
  import 'swiper/css/swiper.css';
  
  export default {
    name:'ThreeSwiper',
    data() {
      return {
        swiperItems: ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4'],
        swiperInstance: null,
      };
    },
    methods:{
      onPrev() {
        if (this.swiperInstance) {
          this.swiperInstance.slidePrev();
        }
      },
      onNext() {
        if (this.swiperInstance) {
          this.swiperInstance.slideNext();
        }
      },

    },
    mounted() {
      this.swiperInstance = new Swiper('.swiper-container', {
        slidesPerView: 3,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 3000, // 自动播放的间隔时间，单位为毫秒
            disableOnInteraction: false, // 用户操作后是否停止自动播放，默认为true
        },
      });
    },
  };
  </script>
  
  <style>
  /* 添加样式以适应Swiper容器 */
  .swiper-container {
    width: 1440px;
    height: 20rem;
  }
  
  .swiper-slide {
    text-align: center;
    transition: 300ms;
    transform: scale(0.8);
    background-color: #eaeaea;
    width: 300px; /* 调整幻灯片的宽度 */
    height: 200px; /* 调整幻灯片的高度 */
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #333;
  }
  
  .swiper-slide-active,.swiper-slide-duplicate-active{
     transform: scale(1);
  	}

  </style>
  